module.exports = __webpack_public_path__ + "img/11.VB.c5c8d0a2.jpg";